// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","container":"_33alt5hlv_fUuYUifZPdOM _15-uIrn7gODHiOpUuDWjwC","internalContainer":"to6xTm7bHo6iomup_EEk9 _2ELtkcMpIJZ1yyH_kfj3I7","contentWrapper":"_1d362hf91lNvccEBKlzjCg","filters":"_5LUbBPhMZt_JMOcyKekWb","productList":"_2s3HQW_xVYnnUXHr2u6-Ys"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/Search.css
// module id = 1085
// module chunks = 1